
import React, { useState } from "react";
import { FaInstagram, FaLinkedin, FaTwitter, FaChevronDown, FaChevronUp } from "react-icons/fa";
import { FiFacebook } from "react-icons/fi";
import Logo from "../../Assets/Svg/mindcareLogo2.svg";
import { IoIosMail } from "react-icons/io";
import { FaSquareXTwitter } from "react-icons/fa6";
import TalkLetter from "./TalkLetter";
import { Link } from "react-router-dom";

const Footer = () => {
  const [openSection, setOpenSection] = useState(null);

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  const sections = [
    {
      title: "Get started",
      id: "getStarted",
      content: (
        <ul>
          <li className="my-3 text-muted"><a href="#">Book a free consultation</a></li>
          <li className="my-3 text-muted"><a href="#">+91 8794267636</a></li>
          <li className="my-3 text-muted"><a href="#">help@mindcare.com</a></li>
        </ul>
      )
    },
    {
      title: "Services",
      id: "services",
      content: (
        <ul>
          <li className="my-3 text-muted"><a href="#">Individual Therapy</a></li>
          <li className="my-3 text-muted"><a href="#">Family Therapy</a></li>
          <li className="my-3 text-muted"><a href="#">Child Therapy</a></li>
        </ul>
      )
    },
    {
      title: "About",
      id: "about",
      content: (
        <ul>
          <li className="my-3 text-muted"><a href="#">For Therapists</a></li>
          <li className="my-3 text-muted"><a href="#">For Psychiatrists</a></li>
          <li className="my-3 text-muted"><Link to="/contact"  onClick={() => window.scrollTo(0, 0)}>Contact Us</Link></li>
          <li className="my-3 text-muted"><Link to="/terms-of-use"  onClick={() => window.scrollTo(0, 0)}>Terms of use</Link></li>
          <li className="my-3 text-muted"><Link to="/privacy-policy"  onClick={() => window.scrollTo(0, 0)}>Privacy Policy</Link></li>
        </ul>
      )
    }
  ];

  return (
    <div className="text-slate-200" data-aos="zoom-in">
      <TalkLetter />
      <footer className="px-4 sm:px-8 lg:px-16 xl:px-28 py-10">
        <div className="flex flex-col md:flex-row md:flex-wrap gap-8 justify-between">
          {/* Logo & Contact */}
          <div className="flex-1 min-w-[230px]">
            <div className="flex items-center gap-2 mb-4">
              <img src={Logo} alt="logo" className="w-10 h-10" />
              <h2 className="text-accent font-bold text-xl font-serif">
                <span className="text-2xl">M</span>indCare
              </h2>
            </div>
            <p className="text-sm leading-relaxed">
              #179, Kothari Nagar, Singanallur, <br />
              Coimbatore - 641 005. INDIA
            </p>
            <div className="flex items-center space-x-2 mt-2 text-sm break-all">
              <IoIosMail className="hover:text-accent transition cursor-pointer" />
              <a href="mailto:admin@cytozon.com">admin@cytozon.com</a>
            </div>
            <div className="gap-4 my-6 flex items-center">
              <FiFacebook className="text-xl hover:text-accent cursor-pointer" />
              <FaSquareXTwitter className="text-xl hover:text-accent cursor-pointer" />
              <FaInstagram className="text-xl hover:text-accent cursor-pointer" />
              <FaLinkedin className="text-xl hover:text-accent cursor-pointer" />
            </div>
          </div>

          {/* Sections with accordion logic */}
          {sections.map(({ title, id, content }) => (
            <div key={id} className="flex-1 min-w-[200px]">
              <div
                onClick={() => toggleSection(id)}
                className="flex items-center justify-between cursor-pointer md:cursor-default md:pb-2"
              >
                <h2 className="text-xl font-semibold">{title}</h2>
                <span className="md:hidden text-accent">
                  {openSection === id ? <FaChevronUp /> : <FaChevronDown />}
                </span>
              </div>
              <div className={`mt-2 ${openSection === id || window.innerWidth >= 768 ? "block" : "hidden"} md:block`}>
                {content}
              </div>
            </div>
          ))}
        </div>
      </footer>
      <div className="py-5 mt-3 text-center border-t text-muted border-dark text-sm px-4">
        © 2024 - Cytozon Technologies Pvt Ltd. | All Rights Reserved {" "}
        <span className="text-accent">Doxzon</span>
      </div>
    </div>
  );
};

export default Footer;
